/**
 * API layer — endpoint wrappers over the shared axios instance (api/client.js).
 */
import api, {
  API_BASE_URL, getAccess, saveAccess, clearAuth,
  onAuthLost, getAuth, initAuth,
  isImpersonating, startImpersonation, stopImpersonation, onImpersonationEnded,
} from './api/client';

export {
  API_BASE_URL, clearAuth, onAuthLost, getAuth, initAuth,
  isImpersonating, startImpersonation, stopImpersonation, onImpersonationEnded,
};

export const PER_PAGE = 50;

// --- Endpoints ---
export const login = (username, password) =>
  api.post('/login', null, { auth: { username, password } }).then((r) => {
    saveAccess(r.data.access_token);
    return r.data;
  });

export const fetchLinks = (page = 1, perPage = PER_PAGE) =>
  api.get('/links', { params: { page, per_page: perPage } }).then((r) => r.data);

export const fetchStatus = () => api.get('/status').then((r) => r.data);

export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const fetchStats = () => api.get('/stats').then((r) => r.data);

export const exportFile = (format) =>
  api.get(`/export/${format}`, { responseType: 'blob' }).then((r) => r.data);

export const clearData = () => api.post('/clear-data').then((r) => r.data);

export const resetStatus = () => api.post('/reset-status').then((r) => r.data);

export const changePassword = (oldPassword, newPassword) =>
  api.post('/change-password', { old_password: oldPassword, new_password: newPassword }).then((r) => r.data);

export const fetchSessions = () => api.get('/sessions').then((r) => r.data);

export const deleteSession = (id) => api.delete(`/sessions/${id}`).then((r) => r.data);

export const acceptInvite = (token, password) =>
  api.post(`/invite/${token}`, { password }).then((r) => r.data);

export const checkAuth = async () => {
  const access = getAccess();
  if (!access) return false;
  try {
    const res = await fetch(`${API_BASE_URL}/status`, {
      headers: { Authorization: `Bearer ${access}` },
    });
    return res.ok;
  } catch {
    return false;
  }
};

export default api;
